<template>
    <div class="home">
        <div class="sigDiv">
            <!-- START ZAIRE LOGO -->
            <svg 
                class="squiggle-animated" 
                version="1.1" id="Layer_1" 
                xmlns="http://www.w3.org/2000/svg" 
                xmlns:xlink="http://www.w3.org/1999/xlink" 
                x="0px" y="0px" 
                viewBox="0 0 329.5 159.67" 
                xml:space="preserve">
                <!-- <path :style="pathStyle" d="M33.3,204.2C47.8,149.1,103.9,66,142.5,41.9s68.6-23.2,73.5,21.3c4.8,44.5-28,103.4-45.4,129.5s-34.8,56.1-31.9,55.1c2.9-1,43.1-33.6,67.2-32.8c21.9,0.8,48.3,11.8,42.5,79.5c-5.8,67.7-52,128.6-71.4,150.9c-19.3,22.2-34.5,17-31.6-0.4s19.3-64.8,75.4-139.2S327.2,186.8,346.5,154c19.3-32.9,6.8-37.7-2.9-28c-9.7,9.7-34.8,58-44.5,78.3c-9.7,20.3-24.2,58,1,52.2s60.3-86.6,83.1-121.8c17.5-27,9.7,12.6,1.9,48.3s-11.6,69.6,11.6,49.3s46.4-103.4,48.3-86s-24.2,71.5-12.6,81.2c11.6,9.7,36.7-9.7,64.8-44.5c28-34.8,56.1-97.6,26.1-88c-30,9.7-49.3,40.6-30.9,40.6s99.6-32.9,94.7-23.2c-4.8,9.7-31.6,31-47,61.9c-15.5,30.9-13.5,50.5-0.9,51.5c12.6,1,74.4-24.6,110.2-63.2s35.3-56.9,30.5-58.9c-4.8-1.9-26.1,6.8-51.2,39.6c-25.1,32.9-43.5,66.7-23.2,84.1c20.3,17.4,44.5-5.8,43.5-14.5"></path> -->
                <!-- <path class="linesss" d="M510.1,26.8c0,0,1.1,0.3,1.8,0.8"></path> -->
                <!-- <path class="linesss" d="M550.6,31.7c0,0,1.9,0.7,2.2,1.8"></path> -->
                <path :style="pathStyle" d="M36.5,2.7s-2-3-8,14-21,65-25,102,4.75,41.59,13,37c13.5-7.5,23-28,30-52s12-43,17-52c0,0-4.5,6.5-3.5,33.5.55,15,3,29,6,36s7.31,18.16,15,12c5-4,10-20,11-41s4-52,5-54,2-1,2-1"/>
                <path :style="pathStyle" d="M146,71.2s3-5,3-10-5-11-10-9-11,8-20,22-19,30-14,32,15-15,19-22,7-13,10-11,3.61,16.87,4,20c1,8,7,8,7,8,3-1,6,5,28-78,0,0-7,47-7,55s1,21,6,22,13.87-12,21-32c5-14,7-32,14-44,0,0-11,21-12,51s10,17.28,12,10.64S218,48.2,228,45.2s19,3,28,25,0,36-17,39-32-9-32-9"/>
                <path :style="pathStyle" d="M147,43.2s13-7,40-14,62-18.38,98-17c26,1,36,7,42,12"/>
            </svg>
            <!-- END ZAIRE LOGO -->
        </div>
        <b-link class="instagramLink" href="https://instagram.com/kinsey_______________" target="_blank">IG 
        </b-link>
        <b-link class="pressLink" to="/press">Press</b-link>
        <b-link class="artistLink" to="/artist">Artist</b-link>
        <b-link class="engineerLink" to="/engineer">Engineer</b-link>
        <p class="symbols text-center">        
            &#9787;<br>
            &#9835;<br>
            &#x2665;<br>
            <!-- &#x2764;<br> -->
            &#x2765;<br>
            &#127181;<br>
            &#127182;<br>
            <!-- &#9774;<br> -->
            &#4042;<br>
            &#9650;<br>
            &#9733;<br>
            &#9824;<br>
            &#9827;<br>
            &#9829;<br>
            &#9830;<br>
            &#9833;<br>
            <!-- &#9851;<br> -->
            &#9789;<br>
            &#9711;<br>
            &#9790;<br>
            <!-- &#9895;<br> -->
            &#10047;<br>
            &#11089;<br>
            &#11044;<br>
            &#128769;<br>
            &#128770;<br>
            &#128771;<br>
            &#128772;<br>
        </p>
        <p class="email">kinsey.ann.watts@gmail.com</p>
    </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  mounted()  {
      this.animateSignature()
  },
  components: {
    // HelloWorld
  },
  methods: {
    animateSignature() {
        // ANIMATE ZAIRE LOGO
        var allPaths = document.querySelectorAll('.squiggle-animated path');
        allPaths.forEach(path  =>  {
            this.draw(path)
        })
    },
    draw(path) {
        var length = path.getTotalLength();
        // Clear any previous transition
        path.style.transition = path.style.WebkitTransition =
            'none';
        // Set up the starting positions
        path.style.strokeDasharray = length + ' ' + length;
        path.style.strokeDashoffset = length;
        // Trigger a layout so styles are calculated & the browser
        // picks up the starting position before animating
        path.getBoundingClientRect();
        // Define our transition
        path.style.transition = path.style.WebkitTransition =
            'stroke-dashoffset 5s ease-in-out';
        // Go!
        path.style.strokeDashoffset = '0';
    },
  },
  computed: {
      pathStyle() {
          return {
            stroke:'#000',
            'stroke-width': '.25rem',
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round',
            fill:'none',
        }
      },
  },
}
</script>
<style lang='css'>
.artistLink, .pressLink, .engineerLink, .instagramLink, .symbols, .email {
    position: absolute;
}
.home {
    padding-left: 3rem;
}
.symbols {
    bottom: 1.5em;
    left: .85em;
    font-size:1.1em;
}
.email {
    bottom: 2em;
    right: 0em;
    writing-mode: vertical-lr;
    text-orientation: sideways;
}
.pressLink {
    top:  1em;
    left:  1em;
}
.instagramLink {
    top:  1em;
    right:  1em;
}
.engineerLink {
    right: 1em;
    bottom: 1em;
}
.artistLink {
    left: 1em;
    bottom: 1em;
}
</style>